import React from 'react';
import Transition from 'react-transition-group/Transition';
import classnames from 'classnames/bind';

import Notification from '../Notification';
import Button from 'elements/Buttons/Button';

import styles from './ActionNotification.css';

class ActionNotification extends Notification {
  static defaultProps = {
    role: 'alert',
    transitionDuration: 200
  }

  render () {
    const {
      actionName,
      highlightedTitle,
      title,
      children,
      role,
      timeout,
      transitionDuration
    } = this.props;

    return (
      <Transition timeout={transitionDuration} in={this.state.active} appear unmountOnExit>
        {(status) => (
          <div
            className={classnames('content-block', styles.notification, styles[status])}
            role={role}
            onMouseEnter={timeout && this.stopTimer}
            onMouseLeave={timeout && this.startTimer}
            style={{
              transitionDuration: `${transitionDuration}ms`
            }}
          >
            <div className={styles.informativeSection}>
              <p className={classnames(styles.informativeMessage, 'hotspot-title')}>
                <span>{highlightedTitle} </span>
                {title}
              </p>
              <p className={classnames(styles.details, 'p small')}>
                {children}
              </p>
            </div>
            <div className={styles.actionSection}>
              <Button
                classes={'secondary white small'}
                onClick={this.handleClickButton}
              >
                {actionName}
              </Button>
            </div>
          </div>
        )}
      </Transition>
    );
  }
}

export default ActionNotification;


// WEBPACK FOOTER //
// ./src/uis/components/Notification/ActionNotification/ActionNotification.js